import styled from 'styled-components/macro';

const ProfileContentSubmitContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  min-height: 100px;
`;

export default ProfileContentSubmitContainer;
